import { z } from 'zod'
import numeral from 'numeral'
import { MIN_AMOUNT } from '../constants'
import { parseAmount } from '../parse-amount'

export const amountFieldSchema = ({ maxAmount = 0 } = {}) =>
  z.preprocess(
    parseAmount,
    z
      .number({ invalid_type_error: 'El monto debe ser numérico' })
      .min(MIN_AMOUNT, `El monto mínimo es ${numeral(MIN_AMOUNT).format('$0,000')}`)
      .max(maxAmount, `El monto máximo es ${numeral(maxAmount).format('$0,000')}`)
  )
